import { Navigate, useLocation } from "react-router-dom";
import LoadingIndicator from "../../components/shared/LoadingIndicator";
import { useAuth } from "../../contexts/AuthContext";

/**
 * PublicOnly Wrapper
 *
 * Protects routes that should ONLY be valid for unauthenticated users (Login, Signup etc).
 * - Shows loading state while checking session
 * - Redirects to Dashboard (/) if already authenticated
 * - Renders children if not authenticated
 */
interface PublicOnlyProps {
    children: JSX.Element;
}

export default function PublicOnly({ children }: PublicOnlyProps) {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return <LoadingIndicator text="Checking session..." />;
    }

    if (user) {
        // If user is already logged in, redirect them away from public pages
        // Check if there was a redirected location in state, otherwise go to dashboard
        const from = (location.state as any)?.from?.pathname || "/";
        return <Navigate to={from} replace />;
    }

    return children;
}
